import styled from '@emotion/styled';
import { css, SerializedStyles } from '@emotion/core';

import ExportSvg from 'assets/icons/export';
import { ICustomTheme } from 'interfaces';
import { PrimaryButton } from 'components';

type Theme = {
  theme?: ICustomTheme;
};

export const Container = styled.div({
  width: '100%',
});

export const ToolBar = styled.div<Theme>(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(4),
}));

export const SortContainer = styled.div<Theme>(({ theme }) => ({
  paddingLeft: theme.spacing(8),
  [theme.breakpoints.down('sm')]: {
    paddingLeft: 0,
  },
}));

export const ExportIcon = styled(ExportSvg)<Theme>(({ theme }) => ({
  marginRight: `${theme.spacing(1)}px !important`,
  [theme.breakpoints.down('sm')]: {
    height: '1rem',
    marginRight: `${theme.spacing(0.5)}px !important`,
  },
}));

export const ExportButton = styled(PrimaryButton)<Theme>(({ theme }) => ({
  width: 'initial',
  '&:hover path': {
    fill: theme.colors.paletteFromBO.primary,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 13,
    height: '2.5rem',
    margin: 0,
  },
}));

export const cssGridContainer = (theme: ICustomTheme): SerializedStyles =>
  css({
    [theme.breakpoints.up('md')]: {
      gridAutoColumns: '1fr',
    },
  });

export const cssGridItem = (theme: ICustomTheme): SerializedStyles =>
  css({
    marginBottom: theme.spacing(2),
    width: 331,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '0 !important',
    },
  });
